import React from 'react';
import dayjs from 'dayjs';
import styled from 'styled-components';

import { UserAvatar } from '../../components/InitialsBadgeTableCell';

const Container = styled.div`
  background-color: white;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  padding: 10px;
  border-left: 1px solid #d9d9d9;
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (min-width: 1200px) {
    flex-direction: row;
    align-items: flex-start;
  }
`;

const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Metadata = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 5px;

  @media (min-width: 1200px) {
    margin-left: auto;
  }
`;

const Timestamp = styled.div`
  color: #9e9e9e;
  font-size: 12px;

  @media (min-width: 576px) {
    font-size: 14px;
  }
`;

type EntryContainerProps = {
  header: React.ReactNode;
  date: number;
  user?: string;
  children?: React.ReactNode;
};

export const EntryContainer: React.FC<EntryContainerProps> = ({ header, date, user, children }) => {
  return (
    <Container>
      <Main>
        {header}
        {children}
      </Main>
      <Metadata>
        <Timestamp>{dayjs.unix(date).format('YYYY-MM-DD HH:mm')}</Timestamp>
        {user && <UserAvatar userName={user} withPopover />}
      </Metadata>
    </Container>
  );
};
